import { createSvgComponent } from "../../../icon/createSvgComponent";
import Slate from "../figma/slate.svg";
export default createSvgComponent(Slate);